import React from "react";
import ActivateCalendarImage from "./ActivateCalendarImage";
import { LuCalendarCheck } from "react-icons/lu";
import { useSupabaseClient } from "@supabase/auth-helpers-react";
import Logo from "./Logo";
import MobileLogo from "./MobileLogo";
import HomeButton from "./HomeButton";
function GrantCalenderAccess() {
  const supabase = useSupabaseClient(); // talk to supabase!

  async function googleSignIn() {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        scopes: "https://www.googleapis.com/auth/calendar",
      },
    });
    if (error) {
      alert("Error logging in to Google provider with Supabase");
      console.log(error);
    }
  }

  return (
    <div className="w-full grid  grid-cols-1 lg:grid-cols-2">
      <main className="flex w-full bg-blue-600 flex-col h-screen">
        <div className="flex items-center justify-center min-h-screen px-4 md:px-6">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
            <div className="flex flex-col items-center justify-center space-y-6">
              <div className="w-60">
                <Logo />
              </div>

              <div className="md:hidden inline-block">
                <MobileLogo />
              </div>
              <div className="bg-green-500 text-white rounded-full p-3">
                <LuCalendarCheck className="h-8 w-8" />
              </div>
              <h1 className="text-2xl md:text-3xl text-center font-bold text-gray-900">
                Authorize Study Buddy
              </h1>
              <div className="space-y-2 text-center">
                <p className="text-gray-500 dark:text-gray-400 text-justify">
                  Connect your calendar to auto-schedule events and meetings,
                  keeping you organized and saving time effortlessly! Please
                  note: For security, you’ll need to authorize your calendar
                  each time you create classes.
                </p>
              </div>
              <button
                onClick={googleSignIn}
                className="px-4 py-2 w-full bg-blue-600 text-white rounded hover:bg-blue-700 transition"
              >
                Grant Calendar Access
              </button>


              <HomeButton />
            </div>
          </div>
        </div>
      </main>
      <div className="hidden lg:block h-screen">
        <ActivateCalendarImage />
      </div>
    </div>
  );
}

export default GrantCalenderAccess;
